console.log('GO FAVORITES CARGADO');

let favorites =
JSON.parse(localStorage.getItem('goFavorites')) || [];

document.querySelectorAll('.go-favorite-btn').forEach(btn => {

    const productId = btn.dataset.productId;

    if(favorites.includes(productId)){

        btn.classList.add('active');

        const icon = btn.querySelector('i');

        icon.className = 'bi bi-clipboard-heart-fill';
    }
});

document.addEventListener('click', function(e){

    const btn = e.target.closest('.go-favorite-btn');

    if(!btn) return;

    e.preventDefault();
    e.stopPropagation();

    const productId = btn.dataset.productId;

    const icon = btn.querySelector('i');

    if(btn.classList.contains('active')){

        btn.classList.remove('active');

        icon.className = 'bi bi-clipboard-heart';

        favorites = favorites.filter(id => id !== productId);

    } else {

        btn.classList.add('active');

        icon.className = 'bi bi-clipboard-heart-fill';

        favorites.push(productId);
    }

    localStorage.setItem(
        'goFavorites',
        JSON.stringify(favorites)
    );

    updateFavoritesCount();

    console.log('FAVORITOS:', favorites);

    console.log(favorites);

});

function updateFavoritesCount(){

    const counter =
    document.getElementById('go-favorites-count');

    const wrapper =
    document.querySelector('.favorite-icon-wrapper');

    if(!counter) return;

    counter.textContent = favorites.length;

    if(favorites.length > 0){
        wrapper.classList.add('has-favorites');
    }else{
        wrapper.classList.remove('has-favorites');
    }
}

updateFavoritesCount();

window.addEventListener('pageshow', function() {

    favorites =
    JSON.parse(localStorage.getItem('goFavorites')) || [];

    updateFavoritesCount();

    document.querySelectorAll('.go-favorite-btn').forEach(btn => {

        const productId = btn.dataset.productId;

        const icon = btn.querySelector('i');

        if(!icon) return;

        if(favorites.includes(productId)){

            btn.classList.add('active');

            icon.className =
            'bi bi-clipboard-heart-fill';

        }else{

            btn.classList.remove('active');

            icon.className =
            'bi bi-clipboard-heart';

        }
    });

});

window.addEventListener('pageshow', function(){

    fetch('/cart.js')
    .then(r => r.json())
    .then(cart => {

        const cartIcon = document.querySelector('#cart-icon-bubble');

        if(!cartIcon) return;

        if(cart.item_count > 0){

            cartIcon.classList.add('has-items');

        }else{

            cartIcon.classList.remove('has-items');

        }

    });

});

document.addEventListener('DOMContentLoaded', updateGoCartIcon);
window.addEventListener('pageshow', updateGoCartIcon);

function updateGoCartIcon() {

    fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {

        const cartIcon = document.querySelector('#cart-icon-bubble .go-cart-icon');

        if (!cartIcon) return;

        if (cart.item_count > 0) {

            cartIcon.classList.remove('go-cart-empty');
            cartIcon.classList.add('go-cart-full');

            cartIcon.innerHTML =
                document.querySelector('#go-cart-full-template')?.innerHTML || cartIcon.innerHTML;

        } else {

            cartIcon.classList.remove('go-cart-full');
            cartIcon.classList.add('go-cart-empty');

            cartIcon.innerHTML =
                document.querySelector('#go-cart-empty-template')?.innerHTML || cartIcon.innerHTML;
        }
    });
}

